import { Trans } from "react-i18next";
import React from "react";
import TableHolder from "./TableHolder";

export const MultiLinesTable = ({ items, selectedOrganisation }) => {
    return (
        <>
            <h2 className="mb-3">
                <span><Trans>All Accrued Holidays</Trans></span> - <span>{selectedOrganisation.name}</span>
            </h2>

            <hr />
            {items.map((item, index) => (
                <>
                    <div className="break-after" key={index}>
                        <div className="mt-5">{item.employee__full_name}</div>
                        <div className="mb-5 pb-2 pt-2">
                            <TableHolder
                                line={item}
                            />
                            <hr />
                        </div>
                    </div>
                </>
            ))}
        </>
    );
};

export default MultiLinesTable;
